import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/Navbar/Navbar.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/Navbar/Navlinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/Toasts/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@3.24.0_next@15.0.4-canary.43_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1_o5geq3hvl74xouzsx5uroffggq/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/main.css");
